import i18n from "@/plugins/i18n";
import moment from "moment";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Name",
          value: "translatableName",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Subject",
          value: "subject",
        },
        {
          text: "Published",
          value: "isPublished",
        },
        {
          text: "Image",
          value: "translatableThumbnail",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: 'Chapter',
        label:  'Chapters',
      },
      {
        key: 'Quest',
        label:  'Quests',
      },
      {
        key: 'ChapterReport',
        label:  'Report',
      },
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
     
    ],
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Name",
          value: "translatableName",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Subject",
          value: "subject",
        },
        {
          text: "Author",
          value: "author",
        },
        {
          text: "Published",
          value: "isPublished",
        },
        {
          text: "Image",
          value: "translatableThumbnail",
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add:{
    fields:[
      {
        type:'string',
        key:'translatableName',
        name:'Theme Name',
        defaultValue:'{"en":"Example Theme","zh":"示例主题","ms":"Contoh Tema"}'
      },
      {
        type:'number',
        key:'year',
        name:'Year',
        defaultValue:moment().format('YYYY'),
      },
      {
        type:'number',
        key:'month',
        name:'Month',
        min:1,
        max:12,
        defaultValue:moment().add(1,'months').format('M'),
      }
    ],
    rules:{
      translatableName: [v => !!v || 'Prize name is required'],
    },
  },
  edit:true,
  delete: true,
};
